<template>
  <div class="copy-writing">
    <div class="copy-item">
      <p class="pdfname" v-for="(item, index) in list" :key="index">
        <!-- <span>{{item.name}}</span> -->
        <a href="javascript:;" @click="goPDF(item.name)" v-text="item.name"></a>
        <img src="../assets/img/arr.png" alt="" />
      </p>
    </div>
  </div>
</template>
<script>
import tdMixin from "@/mixins/td-mixin.js";
export default {
  name: "pdf-list",
  mixins: [tdMixin],
  data() {
    return {
      list: [
        {
          name: "特定传染病危重症疾病保险（公益项目）B款",
          url: `http://ecuat.tk.cn/tk-online/nprd/vivo-insurance/特定传染病危重症疾病保险（公益项目）B款条款.pdf`
          // url:
          //   "http://m.tk.cn/resource/tkms/wap/wapPDF/特定传染病危重症疾病保险（公益项目）B款条款.pdf"
        }
      ]
    };
  },
  methods: {
    goPDF() {
      let pdfurl = `${
        location.origin
      }/tk-online/nprd/vivo-insurance/特定传染病危重症疾病保险（公益项目）B款条款.pdf`;
      location.href = pdfurl;
    }
  },
  created() {
    this.sendTD({ eventId: "BXTKY_BXTKY_LOAD" });
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/copy.scss";
.pdfname {
  display: flex;
  width: 100%;
  padding: 0.2rem 0;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #e7e7ee;
  a {
    flex: 1;
    line-height: 0.36rem;
    font-size: 0.28rem;
    color: #666666;
    padding-left: 0.36rem;
  }
  img {
    width: 0.23rem;
    height: 0.23rem;
    padding-right: 0.36rem;
  }
}
</style>
